import { createSlice } from "@reduxjs/toolkit";
import { returnee_applications } from "../../../types/returnee/returnee_application";

export const approvedReturneeApplications = createSlice({
  name: "approved_returnee_applications",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: returnee_applications;
      }[],
      data: [] as returnee_applications,
    },
  },
  reducers: {
    update_approved_returnee_applications: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload;
    },
    add_approved_returnee_application: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToApprovedPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_approved_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      currentArray.splice(currentIndex, 1);
      state.value.data = currentArray;
    },
    replace_approved_returnee_application: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_approved_returnee_applications: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_approved_returnee_applications,
  add_approved_returnee_application,
  addToApprovedPaginationHistory,
  remove_approved_returnee_application,
  replace_approved_returnee_application,
  clear_approved_returnee_applications,
} = approvedReturneeApplications.actions;

export default approvedReturneeApplications.reducer;
